export default "__VITE_ASSET__61552006__"